import { request } from './http';
import { tokenStore } from './tokenStore';
import { getInitData } from '../telegram/telegram';

type JwtResponse = {
  accessToken: string;
  refreshToken: string;
  id?: string;
};

// POST /identity/rider/telegram-sign — validates Telegram initData server-side
// (HMAC-SHA256) and returns the same JWT shape as the SMS flow.
// Backend may return 400 telegram_contact_required if the rider has not shared
// their phone with the bot yet — caller routes the user back to the bot.
export async function telegramSignIn(): Promise<JwtResponse> {
  const initData = getInitData();
  const res = await request<JwtResponse>('/identity/rider/telegram-sign', {
    method: 'POST',
    auth: false,
    body: { initData },
  });
  tokenStore.setTokens(res.accessToken, res.refreshToken);
  if (res.id) tokenStore.setClientId(res.id);
  return res;
}

export function signOut(): void {
  tokenStore.clear();
}
